const planWeight = {
  SUPERHIGHLIGHTED: 4,
  HIGHLIGHTED: 3,
  SIMPLE: 2,
  'FREE-SUBSIMPLE': 1,
  FREE: 1
};

const sortCredits = credits => {
  if (credits.branchCredits && credits.branchCredits[0] && credits.branchCredits[0].creditItems) {
    credits.branchCredits[0].creditItems.sort((a, b) => {
      if (planWeight[a.publicationType] < planWeight[b.publicationType]) {
        return 1;
      }
      if (planWeight[a.publicationType] > planWeight[b.publicationType]) {
        return -1;
      }
      return 0;
    });
  }
  return credits;
};

const filterCurrentPlan = (credits, currentPlanType) => {
  // SI SE ENVÍA PLAN ACTUAL SE FILTRAN EL PLAN ACTUAL E INFERIORES EN WEIGHT
  if (currentPlanType && credits && credits[0]) {
    return credits.reduce((filteredCredits, current) => {
      if (planWeight[current.publicationType] > planWeight[currentPlanType]) {
        filteredCredits.push(current);
      }
      return filteredCredits;
    }, []);
  }
  return [];
};

const getCredits = (postingsArray, postingBranch, totalCredits) => {
  // SI SE TRATA DE UN ADMINISTRADOR (TIENE CRÉDITOS DE VARIAS BRANCHES), HAY QUE IDENTIFICAR SI ES OPERACIÓN BULK O SINGLE PARA PASARLE LOS CRÉDITOS CORRESPONDIENTES
  if (totalCredits.branchCredits && totalCredits.branchCredits.length > 1) {
    if (postingsArray.length > 1) {
      // SI ES OPERACIÓN EN BULK SE TOMAN LOS CRÉDITOS GLOBALES, NO SE PUEDEN SEPARAR POR BRANCH
      return totalCredits.globalCredits;
    }
    // SI ES UN SOLO POSTING SE FILTRA PARA QUE SE UTILICEN SOLO LOS CRÉDITOS DE LA BRANCH A LA QUE PERTENECE EL POSTING
    return totalCredits.branchCredits.some(credit => parseInt(credit.branchId) === postingBranch)
      ? totalCredits.branchCredits.filter(credit => parseInt(credit.branchId) === postingBranch)[0]
      : [];
  }
  // SI NO TIENE VARIAS BRANCHES ENTONCES NO ES NECESARIO FILTRAR
  if (totalCredits.branchCredits && totalCredits.branchCredits[0]) {
    return totalCredits.branchCredits[0];
  }
  return {};
};

export { sortCredits, filterCurrentPlan, getCredits };
